enum PermissionCode {
  UsersView = 'users.view',
  PaymentMethodsView = 'payment-methods.view',
  CommerceCategoriesView = 'commerce-categories.view',
  ProductCategoriesView = 'product-categories.view',
}
export default PermissionCode;
